/**
 * ProductListContainer
 * --
 */
import React, { useState, useReducer, useEffect } from 'react';
import ProductListPresenter from './ProductListPresenter';

const ProductListContainer = () => {
  
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  // 페이징
  const [currentPage, setCurrentPage] = useState(1);
  // 전체 선택
  const [isCheckedAll, setIsCheckedAll] = useReducer((state, action) => {
    switch (action.type) {
      case 'TOGGLE':
        return !state;
      case 'RESET':
        return false;
      default:
        return state;
    }
  }, false);
  // 선택 목록
  const [checkedList, setCheckedList] = useState([]);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 페이징 처리
   * --
   */
  const handlePagination = (page) => {
    if (currentPage === page) return;

    setCurrentPage(page);
  };

  /**
   * 체크박스 핸들러
   * --
   * @param { boolean } c
   * @param { object | array } d
   * @param { string } t
   */
  const handleChecked = (c, d, t = null) => {
    if (t) {
      // 전체 선택인 경우
      setCheckedList(d);
    } else {
      // 단일 선택인 경우
      if (c) {
        setCheckedList((prev) => [...prev, d]);
      } else {
        setCheckedList((prev) => prev.filter((item) => item.key !== d.key));
      }
    }
  };

  /* ===== HOOKS ===== */
  /**
   * 페이지 변경 시 체크박스 초기화
   * --
   */
  useEffect(() => {
    setIsCheckedAll({ type: 'RESET' });
    setCheckedList([]);
  }, [currentPage]);

  /* ===== RENDER ===== */
  return (
    <>
      <ProductListPresenter
        // State
        currentPage={currentPage}
        isCheckedAll={isCheckedAll}
        checkedList={checkedList}
        // Function
        onPagination={handlePagination}
        onChecked={handleChecked}
        onCheckedAll={setIsCheckedAll}
      />
    </>
  );
};

export default ProductListContainer;
